export default __webpack_public_path__ + "static/media/daviplata.25ec7bb8.svg";